import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ValidRegex } from '../../../shared/regex/validRegex';

@Component({
  selector: 'kt-email-modal',
  templateUrl: './email-modal.component.html',
  styleUrls: ['./email-modal.component.scss']
})
export class EmailModalComponent implements OnInit {
  emailForm: FormGroup;
  isSubmitted = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(ValidRegex.EMAIL_REGEX)]]
    });
  }

  get f() {
    return this.emailForm.controls;
  }

  onSubmit(): void {
    this.isSubmitted = true;

    if (this.emailForm.invalid) {
      return;
    }

    this.activeModal.close(this.emailForm.value.email);
  }

}